import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["preview", "empty", "filename", "status", "action"];

  disconnect() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
  }

  preview(event) {
    const [file] = event.target.files;
    if (!file) return;

    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl);
    this.previewUrl = URL.createObjectURL(file);
    this.previewTarget.src = this.previewUrl;
    this.previewTarget.classList.remove("hidden");
    this.emptyTarget.classList.add("hidden");
    this.filenameTarget.textContent = file.name;
    this.statusTarget.textContent = `${file.type.replace("image/", "").toUpperCase()} · ${this.fileSize(file.size)}`;
    this.actionTarget.textContent = "更换图片";
  }

  fileSize(bytes) {
    return bytes < 1024 * 1024
      ? `${Math.max(1, Math.ceil(bytes / 1024))} KB`
      : `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  }
}
